import {Endpoint} from '@eryxcoop/appyx-comm';

export default class EditOrdersPurchaseOrderNumberEndpoint extends Endpoint {
  adaptValues({ordersNumber, purchaseOrdersNumber}) {
    return {
      "orders_number": ordersNumber,
      "purchase_orders_number": purchaseOrdersNumber,
    }
  }
}